import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML string to prevent XSS attacks.
 * Uses DOMPurify to remove potentially dangerous HTML/JS content
 * while preserving safe formatting tags used by rich text editors.
 *
 * @param {string} html - The HTML string to sanitize
 * @returns {string} - The sanitized HTML string
 */
// DOMPurify's default URI allow-list rejects the `blob:` scheme, so it
// silently strips `src` from freshly-uploaded rich-text images (which use
// `URL.createObjectURL(...)` previews before their first save round-trip).
// The active TipTap editor renders those via a React node view (no sanitize
// pass), but read-only views run this sanitizer → the blob src is dropped →
// broken <img>. We extend the default regex with `blob` (verbatim default +
// `|blob`) so blob: URLs survive. `blob:` URLs are same-origin object
// handles and cannot execute script, so this does not widen XSS surface;
// `javascript:` / `data:` remain blocked exactly as before.
const ALLOWED_URI_REGEXP = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix|blob):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape

export const sanitizeHtml = (html) => {
    if (!html || typeof html !== 'string') return html || '';
    return DOMPurify.sanitize(html, { ALLOWED_URI_REGEXP });
};
